import { MDBAlert, MDBIcon } from 'mdb-react-ui-kit';
import React, { forwardRef, useState } from 'react'
import { useNavigate } from 'react-router';
import { deleteSMSBrand, deleteSMSCampaigns } from '../../../../apiclients/streamsapi_bridge';
import { useTranslation } from 'react-i18next';


const DeleteSMSCampaign = forwardRef((props, ref) => {
    const [internalError, setInternalError] = useState(false);
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    async function removeThisBrand(e) {
        try {
            setInternalError(false);
            props.setIsloading(true);
            let deleteGrpReponse = await deleteSMSCampaigns(JSON.parse(sessionStorage.getItem("admin_session")).siteid, props.campaignObj.campaignid);
            setTimeout(() => { props.setIsloading(false) }, 1000);
            let delInfo = await deleteGrpReponse.json();

            if (delInfo.status == 'success') {
                localStorage.setItem("s_message", delInfo.message);
                props.onClose();



            } else {
                localStorage.setItem("f_message", delInfo.message);
                // window.location.href = "/smslanding";
            }
            navigate("/smslanding", {
                state: { tab: "tab2" },
            });
            window.location.reload();
        } catch (e) {
            console.log(`Unable to process Request :Internal server Error:!`);
            setInternalError(true);
        }
    }
    return (

        <>
            {internalError && (<MDBAlert
                open
                className="alert-center"
                color="danger"
                autohide
                position="bottom-right"
                delay={5000}
            >Internal Server Error</MDBAlert>)}

            <div className="d-flex align-items-center bg-danger bg-opacity-25 p-3  rounded-3 square border border-2 border-danger">
                <MDBIcon fas icon="ban" className="me-3" size="lg" color="danger" />
                <span>{t("RemoveSMSCamptxt")}</span>
            </div>
            {/* <MDBModalFooter>
                <MDBBtn color="secondary" onClick={props.onClose}>
                    {t("cancel")}
                </MDBBtn>
                <MDBBtn onClick={(e) => removeThisBrand(e)}>{t("remove")}</MDBBtn>
            </MDBModalFooter> */}
            <div style={{ display: "none" }}>
                <button ref={ref} onClick={(e) => removeThisBrand(e)}>
                    {t("add")}</button>
            </div>

        </>


    )
});

export default DeleteSMSCampaign
